import {MI} from "../init";
import {MadnesTween} from "../libs/mi/MadnesTween";

/**
 * @constructor
 * @returns {WinViewer}
 */
export function WinViewer() {

    /** @type {MadnesGroup} */
    this._group;

    /** @type {MadnesObject} */
    this._winText;

    /** @type {MadnesObject} */
    this._winTextBg;

    this._bgAlpha = 0.8;
};

/**
 * @param {MadnesGroup} group
 */
WinViewer.prototype.create = function(group) {
    this._group = group;

    this._winTextBg = MI.addImg(MI.getWi() / 2, MI.getHe() / 2, "win_background");
    this._winTextBg.setAnchor(0.5, 0.5);
    this._winTextBg.setVisible(false);

    this._winText = MI.addBitmapText("font_normal_win", MI.getWi() / 2, MI.getHe() / 2 + 26, "", 80);
    this._winText.setAnchor(0.5, 0.5);
    this._winText.setVisible(false);

    this._group.add(this._winTextBg);
    this._group.add(this._winText);

};

/**
 * @param {string|number} win
 */
WinViewer.prototype.setWin = function(win) {
    this._winText.setText(win + "");
};

/**
 * @returns {Promise}
 */
WinViewer.prototype.animWin = function() {

    var _self = this;
    var delay = 1400;

    return new Promise(function(res) {

        _self._winText.setScale(1.4, 1.4);
        _self._winText.setAlpha(0);
        _self._winText.setVisible(true);

        _self._winTextBg.setAlpha(0);
        _self._winTextBg.setVisible(true);

        MI.createTimer().add(function() {

            MI.addTween().to(_self._winText, { 'x': 1, 'y': 1 }, {
                'scale': true,
                'duration': 500,
                'easing': MadnesTween.getEasing('back_out'),
                'callback': res
            });

            MI.addTween().to(_self._winText, { 'alpha': 1 }, {
                'duration': 300
            });

            MI.addTween().to(_self._winTextBg, { 'alpha': _self._bgAlpha }, {
                'duration': 300
            });

        }, delay);
    });
};

/**
 * @param {boolean=} keepBg
 * @returns {Promise}
 */
WinViewer.prototype.animWinHide = function(keepBg) {
    var _self = this;

    return new Promise(function(res) {

        MI.addTween().to(_self._winText, { 'alpha': 0 }, {
            'duration': 200,
            'callback': function() {
                _self._winText.setVisible(false);
                res();
            }
        });

        if(!keepBg) {
            MI.addTween().to(_self._winTextBg, { 'alpha': 0 }, {
                'duration': 200,
                'callback': function() {
                    _self._winTextBg.setVisible(false);
                }
            });
        }
    });
};

/**
 * @param {Function} onCoinDrop
 * @returns {Promise}
 */
WinViewer.prototype.animWinSkip = function(onCoinDrop) {

    var _self = this;

    MI.createTimer().add(onCoinDrop, 200);

    return new Promise(function(res) {

        _self._winText.setScale(1.1, 1.1);
        _self._winText.setAlpha(0);
        _self._winText.setVisible(true);

        _self._winTextBg.setVisible(true);

        MI.addTween().to(_self._winTextBg, { 'alpha': _self._bgAlpha }, {
            'duration': 150
        });

        MI.addTween().to(_self._winText, { 'alpha': 1 }, {
            'duration': 150
        });

        MI.addTween().to(_self._winText, { 'x': 1, 'y': 1 }, {
            'scale': true,
            'duration': 250,
            'callback': res
        });
    });
};

/**
 * @param {boolean=} keepBg
 * @returns {Promise}
 */
WinViewer.prototype.animWinSkipHide = function(keepBg) {

    var _self = this;

    return new Promise(function(res) {

        MI.addTween().to(_self._winText, { 'alpha': 0 }, {
            'delay': 125,
            'duration': 100,
            'callback': function() {
                _self._winText.setVisible(false);
                res();
            }
        });

        if(!keepBg)
        {
            MI.addTween().to(_self._winTextBg, { 'alpha': 0 }, {
                'delay': 125,
                'duration': 100,
                'callback': function() {
                    _self._winTextBg.setVisible(false);
                }
            });
        }
    });
};